import { Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { AppConfig } from 'src/app/services/app.config.services';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { ActiveAgentsComponent } from '../active-agents/active-agents.component';
import { ToastrService } from 'ngx-toastr';
import { log } from 'src/app/utils/logging';
import { LogUpload } from 'src/app/utils/log-upload';
import { Agent } from 'src/app/interfaces/agent.interface';
import { AgentListInfo } from 'src/app/services/agent.list.info';
import { AuditService } from 'src/app/services/audit.service';
import { isFeatureEnabled, isPeepButtonEnabled, isSupervisorChatEnabled } from 'src/app/utils/features';
import { AgentAuxStatus, getAgentAuxStatus } from 'src/app/utils/agent';
import { TranslocoService } from '@ngneat/transloco';
import { IChatMessageRequestPayload, IIceServers, ISWFHMessagePayload, IWebRTCHeartbeatPayload, IWebRTCMessageRequestPayload } from 'src/app/interfaces/messages';
import { generateMessage } from 'src/app/utils/messages';
import { callCloseReasons, WebRTCService } from 'src/app/services/webrtc.service';
import { IWebRTCScreenCaptureDetails } from 'src/app/interfaces/webRTC.interface';
import { getUTCDateObj } from 'src/app/utils/timeManager';
import { SupervisorService, Widgets } from 'src/app/services/supervisor.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.sass']
})
export class ChatComponent implements OnInit, OnChanges {
  violationHistory: any;
  @Input() AgentLanId: string;
  violationsKeys: any = [];
  showPopUp = false;
  appConfig = AppConfig.settings;
  violationIndex: number;
  txtChat: string;
  chatEventsToBeConsidered = AppConfig.settings.ChatEvents;
  @Input() selectedProfilePic: string;
  @Input() supervisorCanViewMedia: boolean;
  isEmojiPickerShown: boolean = false;

  timerCount = 0;
  showApprovalPopUp = false;
  @Output() addChatToEventHistory: EventEmitter<any> = new EventEmitter()
  @ViewChild('scrollChat', { read: ElementRef }) public scrollChat: ElementRef<any>;
  maximized: boolean;
  ShowChat = true;

  previousAgentLanId: string;
  loading = true;
  collapsed: boolean;

  isPeepButtonEnabled: boolean = false;
  isBlockButtonEnabled: boolean = false;
  isUnblockButtonEnabled: boolean = false;
  isScreenGrabButtonEnabled: boolean = false;
  // isCallButtonEnabled: boolean = false;
  isSupervisorChatEnabled: boolean = false;
  isBargeInButtonEnabled: boolean = false;
  showStealthDeactivateButton: boolean = false;

  showFlag: boolean = false;
  selectedImageIndex: number = -1;
  selectedViolationId: string = "";
  imageObject: Array<object> = [];

  callTime: number = 0;
  callType: "bargeIn" | "av" = "bargeIn";
  callCounter: NodeJS.Timeout;
  localStream: MediaStream;
  offerOptions: RTCOfferOptions = {
    offerToReceiveAudio: true,
    offerToReceiveVideo: true,
  };
  isAnswerReceived: boolean = false;
  pendingIceCandidates: RTCIceCandidateInit[] = [];
  peerConnection: RTCPeerConnection;
  webRTCConnectionTimer: NodeJS.Timeout;
  glanceSessionHeartbeat: NodeJS.Timeout;
  @ViewChild('local_video') localVideo: ElementRef;
  @ViewChild('received_video') remoteVideo: ElementRef;

  RemoteMuted: boolean;
  LocalVideoMute: boolean;
  LocalAudioMute: boolean;
  // cameraReady = false;

  logUploader: LogUpload = new LogUpload("ChatComponent");

  chatSectionLabel: string = "";
  peepLabel: string = "";
  screenblockLabel: string = "";
  screenUnblockLabel: string = "";
  screenGrabLabel: string = "";
  // callLabel: string = "";
  bargeInLabel: string = "";
  deactivateStealthModeLabel: string = "";
  showChatLabel: string = "";
  hideChatLabel: string = "";
  minimizeLabel: string = "";
  maximizeLabel: string = "";
  noDataFoundLabel: string = "";
  loadingLabel: string = "";
  muteAudioLabel: string = "";
  unmuteAudioLabel: string = "";
  muteVideoLabel: string = "";
  unmuteVideoLabel: string = "";
  endCallLabel: string = "";
  eventIdLabel: string = "";
  emojiLabel: string = "";
  sendAMessageLabel: string = "";
  stealthModeRequestedLabel: string = "";
  stealthModeApprovalLabel: string = "";
  allowLabel: string = "";
  denyLabel: string = "";
  noScreensAvailableErrorMessage: string = "";
  glanceLicenseLimitErrorMessage: string = "";
  changeScreenLabel: string = "";

  constructor(public trsService: TrsEventsService,
    private activeAgentObj: ActiveAgentsComponent, private toastrService: ToastrService, private agentListInfoService: AgentListInfo,
    @Inject(PLATFORM_ID) private _platform: Object, private auditService: AuditService, private translationService: TranslocoService,
    public webrtcInfoService: WebRTCService, public supervisorService: SupervisorService) {
    this.updateComponentLabels();
  }

  ngOnInit(): void {
    // try {
    log.debug(`Chat Component ngonit`);

    this.supervisorService.maximizedWidget$.subscribe((widget: Widgets) => {
      if (widget === 'Chat') {
        this.maximized = true;

        if (this.webrtcInfoService.getCallingAgentLanId().toLowerCase() !== this.AgentLanId.toLowerCase())
          this.ShowChat = true;
      }
      else this.maximized = false;
    })

    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "UPDATE_APP_LABELS": this.updateComponentLabels(); break;
        case "loadNextViolationsData": this.previousAgentLanId = ''; this.violationHistory = []; break;
        case "ADDTOCHATUI": this.addEventToChatUI(response.data); break;
        case "LOADNEXTVIOLATIONS": this.OnLoadMoreViolations(); break;
        case "VIOLATIONWORKFLOW":
        case "AGENT_CHANGED":
        case "SELECTED_AGENT": this.selectAgent(response.data); break;
        case "ANSWER": this.setRemoteDescriptionOfPeerConnection(response.data); break;
        case "TRICKLEICE": this.addTrickleIceToPeerConnection(response.data); break;
        case "ERROR":
          this.toastrService.error("An error occurred, please try again later.");
          if (this.webrtcInfoService.isCallInProgress() == true)
            this.closeVideoCall('error');
          break;
        case "OFFERDECLINED":
        // case "BARGEINDECLINED": this.closeVideoCall('agent-declined'); break;
        case "BARGEININITRESPONSE": this.onReceivedScreenDevices(response.data); break;
        case "BARGEININITDECLINED": this.onBargeInInitDeclined(response.data); break;
        case "BARGEINLIMITREACHED": this.onScreenGlanceLicenseLimitReached(response.data); break;
        case "ENDBARGEIN": this.onAgentEndedBargeIn(response.data); break;
        case "START_SCREEN_SHARE_CALL": this.bargeIn(response.data); break;
        case "UPDATE_CHAT_FOR_AGENT": this.updateChatUIForAgent(response.data); break;
        case "PEEPCOMPLETE":
        case "PEEPDENIED":
          this.handlePeepResponse(response.data);
          break;
        case "SCREENGRABDATA":
        case "SCREENGRABDENIED":
          this.handleScreenGrabResponse(response.data);
          break;
        case "SIGNEDMEDIAURL":
          if (response.data.ViolationId === this.selectedViolationId) {
            this.imageObject = [{
              image: response.data.ScreenShotUrl,
            }];
          }
          break;
        case "AUXCODECHANGE_INTERNAL":
          if (response.data != null && response.data !== "") {
            this.updateChatUIForAgent(response.data);

            if (this.webrtcInfoService.isCallInProgress() == true && this.webrtcInfoService.getCallingAgentLanId() === response.data) {
              const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(response.data);
              if (agentInfo != null)
                if (this.hasAgentGoneOnBreak(agentInfo) === true) {
                  log.info(`Agent ${response.data} aux status changed to break while call is in progress, closing video call`);
                  this.closeVideoCall('agent-aux-change-break');
                }
                else if (getAgentAuxStatus(agentInfo) === 'logged-out') {
                  log.info(`Agent ${response.data} aux status changed to logged out while call is in progress, closing video call`);
                  this.closeVideoCall('agent-aux-change-loggedout');
                }
            }
          }
          break;
        case "LOGOUT_SUPERVISOR":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor is logging out while call is in progress, closing video call`);
            this.closeVideoCall('supervisor-logout');
          }
          break;
        case "NAVIGATE_TO_ALL_AGENTS":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor navigated to all agents while call is in progress, closing video call`);
            this.closeVideoCall('navigate-all-agents');
          }
          else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
            this.webrtcInfoService.clearScreenShareScreenInfo();
          break;
        case "REFRESH":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor refresh while call is in progress, closing video call`);
            this.closeVideoCall('refresh');
          }
          else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
            this.webrtcInfoService.clearScreenShareScreenInfo();
          break;
        case "DASHBOARD_MODE":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor navigated to dashboard view while call is in progress, closing video call`);
            this.closeVideoCall('navigate-dashboard');
          }
          else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
            this.webrtcInfoService.clearScreenShareScreenInfo();
          break;
        case "GAMIFICATION_MODE":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor navigated to gamification view while call is in progress, closing video call`);
            this.closeVideoCall('navigate-gamification');
          }
          else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
            this.webrtcInfoService.clearScreenShareScreenInfo();
          break;
        case "SUPERADMIN_MODE":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor navigated to superadmin view while call is in progress, closing video call`);
            this.closeVideoCall('navigate-superadmin');
          }
          else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
            this.webrtcInfoService.clearScreenShareScreenInfo();
          break;
        case "BROWSER_TAB_CLOSE":
          if (this.webrtcInfoService.isCallInProgress() == true) {
            log.info(`Supervisor closed the browser/tab while call is in progress, closing video call`);
            this.closeVideoCall('supervisor-tab-close');
          }
          else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
            this.webrtcInfoService.clearScreenShareScreenInfo();
          break;
        case "CLOSE_SCREEN_SHARE_POPUP":
          if (this.webrtcInfoService.isCallInProgress() == false && this.webrtcInfoService.getIsBargeInInitRequestSent() == true) {
            this.webrtcInfoService.clearScreenShareScreenInfo();
            this.updateChatUIForAgent(this.AgentLanId);
          }
          break;
      }
    });

    if (this.trsService.events[this.trsService.selectedAgentId]) {
      this.violationHistory = this.trsService.events[this.trsService.selectedAgentId];
      this.violationsKeys = Object.keys(this.violationHistory);
      this.loading = false;
    }

    this.scrollToBottom();
    // if (this.appConfig.Call.Enable) {
    //   log.debug(`Requesting Media Devices`);
    //   this.requestMediaDevices();
    // }
  }

  ngOnChanges(val: SimpleChanges) {
    if (val.AgentLanId != null) {
      if (val.AgentLanId.previousValue != null) {
        this.previousAgentLanId = val.AgentLanId.previousValue;
      }

      if (val.AgentLanId.previousValue !== val.AgentLanId.currentValue)
        this.isEmojiPickerShown = false;
    }
  }

  peepRequest() {
    this.isPeepButtonEnabled = false;
    this.activeAgentObj.peepRequest(this.AgentLanId);
    this.auditService.AuditSupervisorUsage(10, this.AgentLanId);
  }

  screenBlock() {
    this.activeAgentObj.screenBlock();
    this.auditService.AuditSupervisorUsage(11, this.AgentLanId)
  }

  screenUnBlock() {
    this.activeAgentObj.screenUnBlock();
    this.auditService.AuditSupervisorUsage(12, this.AgentLanId);
  }

  screenGrab() {
    this.isScreenGrabButtonEnabled = false;
    this.activeAgentObj.handleScreenGrab(this.AgentLanId);
    this.auditService.AuditSupervisorUsage(13, this.AgentLanId);
  }

  deactivateStealthMode() {
    this.activeAgentObj.deactivateStealthMode();
    this.showStealthDeactivateButton = false;
  }

  OnLoadMoreViolations() {
    if (this.trsService.events[this.trsService.selectedAgentId] == null) {
      this.violationHistory = {};
      this.violationsKeys = [];
      this.loading = false;
      return;
    }
    this.violationHistory = this.trsService.events[this.trsService.selectedAgentId];
    this.violationsKeys = Object.keys(this.violationHistory);
    this.loading = false;
  }

  // loadMoreViolations(response: any) {
  //   let scroll = false;
  //   if (response.data.Violations[this.AgentLanId] == undefined) {
  //     this.loading = false;
  //     return;
  //   }
  //   if (!response.data.Violations[this.AgentLanId].length) {
  //     return;
  //   }

  //   if (this.previousAgentLanId == null) {
  //     if (!this.violationHistory) {
  //       this.previousAgentLanId = response.data.AgentList[0].LanID;
  //       this.violationHistory = [];
  //     }
  //   }
  //   else if (this.previousAgentLanId == response.data.AgentList[0].LanID || this.previousAgentLanId == '') {
  //   }
  //   else {
  //     this.violationHistory = [];
  //   }

  //   response.data.Violations[this.AgentLanId].forEach((violation: any, index: any) => {
  //     violation.ShowInChat = false;
  //     violation.Show = true;
  //     if (this.appConfig.ChatEvents
  //       .includes(violation.ViolationName)) {
  //       violation.ShowInChat = true;
  //       violation.Show = false;
  //     }
  //   });
  //   this.previousAgentLanId = this.AgentLanId;
  //   if (this.violationHistory) {
  //     scroll = false;
  //   }
  //   this.violationHistory = response.data.Violations[this.AgentLanId].concat(this.violationHistory);
  //   this.violationsKeys = Object.keys(this.violationHistory);
  //   this.timerCount = 0;
  //   this.loading = false;
  //   if (scroll) {
  //     this.scrollToBottom();
  //   }
  // }

  changeAuxCode() {
    let data = { AuxCode: '2', AgentLanId: this.AgentLanId };
    this.sendEvent("CHANGE_AUX_CODE", data);
  }

  // showCall() {
  //   if (this.maximized) {
  //     if (this.callAgentId && this.callAgentId == this.AgentLanId) {
  //       return true;
  //     }
  //     else {
  //       return false;
  //     }
  //   }
  //   else {
  //     if (this.callAgentId && this.callAgentId == this.AgentLanId) {
  //       if (this.ShowChat) {
  //         return false;
  //       }
  //       else {
  //         return true;
  //       }
  //     }
  //     else {
  //       return false;
  //     }
  //   }
  // }

  // showChat() {
  //   if (this.maximized) {
  //     if (this.callAgentId && this.callAgentId == this.AgentLanId) {
  //       if (this.ShowChat) {
  //         return true;
  //       }
  //       else {
  //         return false;
  //       }
  //     }
  //     else {
  //       return true;
  //     }
  //   }
  //   else {
  //     if (this.callAgentId && this.callAgentId == this.AgentLanId) {
  //       if (this.ShowChat) {
  //         return false;
  //       }
  //       else {
  //         return true;
  //       }
  //     }
  //     else {
  //       return false;
  //     }
  //   }
  // }

  selectAgent = (lanId: string): void => {
    log.info(`Selecting agent ${lanId} in chat component`);
    this.txtChat = "";
    this.isEmojiPickerShown = false;

    if (this.webrtcInfoService.isCallInProgress() === true && lanId.toLowerCase() !== this.webrtcInfoService.getCallingAgentLanId().toLowerCase())
      this.closeVideoCall('agent-change');
    else if (this.webrtcInfoService.getIsBargeInInitRequestSent() == true)
      this.webrtcInfoService.clearScreenShareScreenInfo();

    // if (this.webrtcInfoService.isCallInProgress() === true && lanId.toLowerCase() === this.webrtcInfoService.getCallingAgentLanId().toLowerCase()) {
    //   this.maximized = true;
    //   this.ShowChat = false;
    // }

    // if (this.callAgentId) {
    //   if (this.callAgentId == this.AgentLanId) {
    //     this.ShowChat = false;
    //   }
    //   else {
    //     this.ShowChat = true;
    //   }
    // }
    // else {
    //   this.ShowChat = true;
    // }

    this.violationHistory = this.trsService.events[this.trsService.selectedAgentId];
    if (this.violationHistory) {
      this.violationsKeys = Object.keys(this.violationHistory);
    }

    this.timerCount = 0;
    this.loading = false;
    this.scrollToBottom();

    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(this.AgentLanId);
    if (agentInfo != null) {
      if (agentInfo.IsStealthModeActivated)
        this.showStealthDeactivateButton = true;
      else this.showStealthDeactivateButton = false;
    }
  }

  updateChatUIForAgent = (lanId: string): void => {
    if (lanId == null || lanId === "" || lanId !== this.AgentLanId)
      return;

    this.isSupervisorChatEnabled = isSupervisorChatEnabled(lanId, this.agentListInfoService);
    this.setPeepButtonVisibility(lanId);

    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanId);

    if (agentInfo != null) {
      const currentAuxCode: AgentAuxStatus = getAgentAuxStatus(agentInfo);

      //This section is to handle the screen block button appearing in chat
      if (agentInfo.IsScreenBlocked === true) {
        //This means that there is already a screen block for this agent, so we dont show the screen block button
        this.isBlockButtonEnabled = false;
        this.isUnblockButtonEnabled = true;
        // this.isCallButtonEnabled = false;
        this.isBargeInButtonEnabled = false;
      }
      else if (agentInfo.IsStealthModeActivated === true) {
        //No current screenblock for agent
        this.isUnblockButtonEnabled = false;

        //If screenblock is disabled during stealth mode
        const screenblockDisabledDuringStealthModeEnabled: boolean = isFeatureEnabled("TRS_DISABLE_SCREENBLOCK_STEALTH_MODE_ENABLED", agentInfo);

        this.isBlockButtonEnabled = !screenblockDisabledDuringStealthModeEnabled;

        this.isBargeInButtonEnabled = isFeatureEnabled("AllowSupervisorToBargeIn", agentInfo);
        // this.isCallButtonEnabled = this.appConfig.Call.Enable;
      }
      else {
        //No current screenblock for agent
        this.isUnblockButtonEnabled = false;

        const screenblockBeforeLoginEnabled: boolean = isFeatureEnabled("TRS_SCREENBLOCK_BEFORE_LOGIN_ENABLED", agentInfo);
        const screenblockEnabled: boolean = isFeatureEnabled("TRS_SCREEN_BLOCK_ENABLED", agentInfo);

        //Now based on the status of the agent we perform some functionality
        if (currentAuxCode === "available") {
          //During available state depending on the features TRS_SCREENBLOCK_BEFORE_LOGIN_ENABLED and TRS_SCREEN_BLOCK_ENABLED we enable the block button
          if (screenblockBeforeLoginEnabled !== false && screenblockEnabled !== false)
            this.isBlockButtonEnabled = true;
          else this.isBlockButtonEnabled = false;

          // if (screenblockBeforeLoginEnabled === false && screenblockEnabled === false) 
          //   this.isBlockButtonEnabled = false;
          // else if (screenblockBeforeLoginEnabled !== false && screenblockEnabled !== false) 
          //   this.isBlockButtonEnabled = true;
          // else if (screenblockBeforeLoginEnabled !== false && screenblockEnabled === false) 
          //   this.isBlockButtonEnabled = false;
          // else if (screenblockBeforeLoginEnabled === false && screenblockEnabled !== false)
          //   this.isBlockButtonEnabled = false;
        }
        else if (currentAuxCode === "logged-out" || this.hasAgentGoneOnBreak(agentInfo) === true) {
          //During logged out or break state there is no point in doing a screen block
          this.isBlockButtonEnabled = false;
        }
        else {
          //During logged in state we have to enable the buttons
          if (screenblockEnabled === false) {
            this.isBlockButtonEnabled = false;
          } else this.isBlockButtonEnabled = this.webrtcInfoService.isCallInProgress() === false;
        }
      }

      //Agents screen should not be blocked, else there is no point of supervisor doing screen-grab, call and barge-in
      if (agentInfo.IsScreenBlocked === false) {
        //Section to handle screen grab, call and barge in buttons appearing in chat
        //If user is logged out or on break button will be hidden, else we show based on config/features
        if (currentAuxCode === "logged-out" || this.hasAgentGoneOnBreak(agentInfo) === true) {
          this.isScreenGrabButtonEnabled = false;
          // this.isCallButtonEnabled = false;
          this.isBargeInButtonEnabled = false;
        }
        else if (currentAuxCode === "available") {
          this.isScreenGrabButtonEnabled = this.appConfig.ScreenGrab.Enable;
          // this.isCallButtonEnabled = false;
          this.isBargeInButtonEnabled = false;
        }
        else {
          this.isScreenGrabButtonEnabled = this.appConfig.ScreenGrab.Enable;

          if (this.webrtcInfoService.isCallInProgress() === true || this.webrtcInfoService.getIsBargeInInitRequestSent() === true) {
            this.isScreenGrabButtonEnabled = false;
            this.isBargeInButtonEnabled = false;
            // this.isCallButtonEnabled = false;
          }
          else {
            this.isScreenGrabButtonEnabled = this.appConfig.ScreenGrab.Enable;
            this.isBargeInButtonEnabled = isFeatureEnabled("AllowSupervisorToBargeIn", agentInfo);

            // if (this.appConfig.Call.Enable === true) {
            //   if (this.isCallInProgress() === false)
            //     this.isCallButtonEnabled = true;
            //   else this.isCallButtonEnabled = false;
            // }
            // else this.isCallButtonEnabled = false;
          }
        }
      }
      else {
        //Disable if the agents screen is already blocked
        this.isScreenGrabButtonEnabled = false;
        // this.isCallButtonEnabled = false;
        this.isBargeInButtonEnabled = false;
      }

      //Section to handle stealth mode deactivate button
      this.showStealthDeactivateButton = agentInfo.IsStealthModeActivated;

    }
    else log.error(`There is no agent info available in service for agent ${lanId}`);
  }

  addEventToChatUI(data: any) {
    if (this.violationHistory == null)
      this.violationHistory = [];

    if (Object.keys(this.violationHistory).length > 0) {
      // if (this.violationHistory[Object.keys(this.violationHistory).length - 1] != null) {
      //   if (this.violationHistory[Object.keys(this.violationHistory).length - 1] != data) {
      //     this.violationHistory.push(data);
      //   }
      // }
    }
    else {
      this.violationHistory = [];
      this.violationHistory.push(data);
    }

    this.violationsKeys = Object.keys(this.violationHistory);
    this.timerCount = 0;
    this.scrollToBottom();
  }

  updateStealthModeActionTo(allow: boolean, violationIndex: number) {
    let allowStatus = allow ? "StealthMode Approved" : "StealthMode Denied";
    let data = {
      "AgentLanId": this.AgentLanId,
      "AllowStatus": allow,
      "ViolationDateTime": new Date(),
      "ViolationName": allowStatus,
      "Show": false,
      "ShowInChat": true
    };
    if (allowStatus) {
      this.showStealthDeactivateButton = true;
    }
    this.sendEvent("CUSTOM_STEALTHMODE_ACTION", data);
    this.showApprovalPopUp = false;
    this.violationHistory[violationIndex].isHandled = true;
    this.timerCount = 0;
    this.scrollToBottom();
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  toggleMaximize = (): void => this.supervisorService.ToggleLastMaximizedWidget('Chat');

  toggleChat() {
    this.ShowChat = !this.ShowChat;
  }

  startCallTime = (): void => {
    this.callCounter = setInterval(() => {
      this.callTime++;
      if (this.webrtcInfoService.isCallInProgress() === false)
        clearInterval(this.callCounter);
    }, 1000);
  }

  showStealthModeApprovalPopUp(violationIndex: any) {
    this.violationIndex = violationIndex;
    if (this.violationHistory[violationIndex].ChatMessage != 'STEALTH MODE REQUESTED') {
      return;
    }
    if (this.activeAgentObj.pendingStealthRequested[this.AgentLanId] == null) {
      this.violationHistory[violationIndex].isHandled = true;
      return;
    }
    if (!this.violationHistory[violationIndex].isHandled) {
      this.showApprovalPopUp = true;
    }
  }

  hideStealthModeApprovalPopUp() {
    this.showApprovalPopUp = false;
  }

  hideViolationDetailsPopUp(data: any) {
    this.showPopUp = false;
  }

  showViolationDetailsPopUp(violationIndex: any) {
    if (!this.supervisorCanViewMedia) {
      return;
    }

    this.violationIndex = violationIndex;

    switch (this.violationHistory[violationIndex].ViolationName) {
      case "Screen Grab Response":
        this.showLightbox(violationIndex);
        break;
      case "PEEPCOMPLETE":
      case "PEEP Response":
      case "Peep response received":
      case "Check-In":
      case `Check-In response received`:
      case "AuthenticationSucceeded":
        this.showPopUp = true;
        break;
    }
  }

  sendEvent = (eventName: any, responseData: any): void => this.trsService.evtdata.next({
    "eventName": eventName,
    "data": responseData,
  })

  toggleMute(streamType: string, streamMediaType: string) {
    switch (streamType) {
      case 'local':
        switch (streamMediaType) {
          case 'audio':
            this.localVideo.nativeElement.getAudioTracks()[0].enabled = !this.localVideo.nativeElement.getAudioTracks()[0].enabled;
            break;
          case 'video':
            this.localVideo.nativeElement.getVideoTracks()[0].enabled = !this.localVideo.nativeElement.getVideoTracks()[0].enabled;
            break;
        }
        break;
      case 'remote':
        switch (streamMediaType) {
          case 'audio':
            this.remoteVideo.nativeElement.getAudioTracks()[0].enabled = !this.remoteVideo.nativeElement.getAudioTracks()[0].enabled;
            break;
          case 'video':
            this.remoteVideo.nativeElement.getVideoTracks()[0].enabled = !this.remoteVideo.nativeElement.getVideoTracks()[0].enabled;
            break;
        }
        break;
    }
  }

  scrollToBottom() {
    try {
      let interval = setInterval(() => {
        this.timerCount += 1;
        if (this.timerCount === 1) {
          clearInterval(interval);
          if (this.violationHistory) {
            this.violationsKeys = Object.keys(this.violationHistory);
            if (this.scrollChat) {
              this.scrollChat.nativeElement.scrollTop = this.scrollChat.nativeElement.offsetHeight +
                this.scrollChat.nativeElement.scrollHeight;
            }
          }
        }
      }, 1000);

      setTimeout(function () {
        clearInterval(interval);
      }, 2000) // stop it after 10seconds
    } catch (err) { }
  }

  onKeydown(event: { key: string; }) {
    if (event.key === "Enter") {
      this.sendChatMessage();
    }
    this.timerCount = 0;
    this.scrollToBottom();
  }

  sendChatMessage = (): void => {
    if (!this.txtChat)
      return;

    this.addChatToEventHistory.emit({
      AgentLanId: this.AgentLanId,
      ChatMessage: this.txtChat,
    });
    this.timerCount = 0;
    this.scrollToBottom();

    const payload: IChatMessageRequestPayload = {
      EventName: "CHATMESSAGE",
      AgentLanId: this.AgentLanId, //Receiver of the message
      ChatMessage: this.txtChat, // the message
      Sender: this.trsService.supervisorId,
      ShowInChat: true,
    };
    const request: ISWFHMessagePayload = generateMessage("TRS", "TRS", payload, this.trsService);

    this.sendEvent("SendChatMessage", request);
    this.auditService.AuditSupervisorUsage(14, this.AgentLanId, undefined, this.txtChat);

    this.txtChat = "";
    this.timerCount = 0;
    this.scrollToBottom();
    this.isEmojiPickerShown = false;
  }

  showLightbox(violationIndex: number) {
    if (this.violationHistory[violationIndex] != null) {
      const selectedViolationId: string | null = this.violationHistory[violationIndex].ViolationId;

      this.imageObject = [{
        image: "",
      }];

      if (selectedViolationId != null && selectedViolationId !== "") {
        this.selectedViolationId = selectedViolationId;
        this.selectedImageIndex = 0;
        this.showFlag = true;
        this.refreshMediaURLs(this.violationHistory[violationIndex].EventId, this.violationHistory[violationIndex].ViolationId);
      }
      else
        log.error("There is no violation id available for this event", this.violationHistory[violationIndex]);
    }
  }

  closeEventHandler() {
    this.showFlag = false;
  }

  // videoAudioCall = async () => {
  //   if (this.appConfig.Call.Enable === true) {
  //     if (this.cameraReady === false) {
  //       await this.requestMediaDevices();
  //       if (this.cameraReady === false) {
  //         return;
  //       }
  //     }
  //   }
  //   this.callType = "av";
  //   this.callState = 'Calling....';
  //   this.ShowChat = false;
  //   this.maximized = true;
  //   this.startLocalVideo('OFFER');
  //   this.call('OFFER');
  // }

  selectScreenToShare = (): void => {
    const payload: IWebRTCMessageRequestPayload = {
      MessageType: 'BARGEININIT',
      Body: '',
      MediaId: 'Video',
      Index: 0,
      From: this.trsService.supervisorId,
      To: this.trsService.selectedAgentId,
      FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
      ToId: this.trsService.selectedAgentId,
      Candidate: '',
      ScreenIds: this.webrtcInfoService.getSelectedScreensForScreenShare(),
      ClientName: this.trsService.clientName ?? "",
      CreatedDateTime: getUTCDateObj(),
      Message: '',
      UniqueId: this.webrtcInfoService.getUniqueIdForSession(true),
      AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(this.trsService.selectedAgentId)?.AgentCurrentAuxCode ?? 'na',
    };

    log.info(`Unique id generated for this screen glance session: ${payload.UniqueId}`);

    const requestMessage: ISWFHMessagePayload = generateMessage('WEBRTC', `TRS_${this.trsService.selectedAgentId}`, payload, this.trsService);

    this.auditService.AuditScreenGlance('discovery', this.trsService.selectedAgentId, `${this.webrtcInfoService.getUniqueIdForSession()}`);
    this.webrtcInfoService.updateIsBargeInInitRequestSent(true);

    this.updateChatUIForAgent(this.trsService.selectedAgentId);

    log.info(`Sending BARGEININIT request`);
    this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);
  }

  onReceivedScreenDevices = (response: { body: string, To: string, IceServers: IIceServers[], UniqueId: string, From: string }): void => {
    if (response.From !== this.trsService.supervisorId || response.UniqueId !== this.webrtcInfoService.getUniqueIdForSession())
      return;

    if (response != null && response.body != null && response.body !== "") {
      this.webrtcInfoService.updateScreenShareScreenInfo(JSON.parse(response.body));

      const screenDetails: IWebRTCScreenCaptureDetails[] = this.webrtcInfoService.getScreenShareDetails();

      log.info(`Received ${screenDetails.length} screen devices`);

      log.info(`Applying ICE Transport Policy: ${this.appConfig.ScreenGlance.WebRTCSettings.ICETransportPolicy}`);
      this.webrtcInfoService.updateICETransportPolicy(this.appConfig.ScreenGlance.WebRTCSettings.ICETransportPolicy);

      if (response.IceServers != null && response.IceServers.length > 0) {
        log.info(`Applying ICE Servers (${response.IceServers[0].Urls.length})`);
        this.webrtcInfoService.updatePeerConnectionConfig(response.IceServers);
      }
      else log.warn(`No ICE Servers received`);

      if (screenDetails.length > 1) {
        log.info(`Showing screen selection popup to supervisor`);
        this.sendEvent("SHOW_SCREEN_DEVICE_SELECTION_POPUP", response.To);
      }
      else this.bargeIn({ AgentLanId: response.To, SelectedScreenIds: [screenDetails[0].id] });
    }
    else {
      this.toastrService.error(this.noScreensAvailableErrorMessage);
      this.auditService.AuditScreenGlance('error', response.To, this.webrtcInfoService.generateAuditEndReason('no-screens-available'));

      if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession()) {
        this.webrtcInfoService.clearScreenShareScreenInfo();
        this.updateChatUIForAgent(response.To);
      }
    }
  }

  onScreenGlanceLicenseLimitReached = (response: { message: string, To: string, From: string, UniqueId: string }): void => {
    if (response.From !== this.trsService.supervisorId)
      return;

    this.auditService.AuditScreenGlance('error', response.To, this.webrtcInfoService.generateAuditEndReason('license-limit-reached', {
      count: response.message,
    }));

    if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession()) {
      this.toastrService.error(`${this.glanceLicenseLimitErrorMessage} (${response.message})`);
      this.closeVideoCall('license-limit-reached');
    }
  }

  onBargeInInitDeclined = (response: { message: string, To: string, UniqueId: string, From: string }): void => {
    if (response.From !== this.trsService.supervisorId)
      return;

    switch (response.message) {
      case "Screen Glance Declined As Another Session Is In Progress":
        if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession())
          this.toastrService.error(this.webrtcInfoService.generateEndReason("BARGEIN_DECLINED_ANOTHER_SESSION_IN_PROGRESS", {
            agentLanId: response.To,
          }));
        this.auditService.AuditScreenGlance('decline', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEIN_DECLINED_ANOTHER_SESSION_IN_PROGRESS", {
          agentLanId: response.To,
        }));
        break;
      case "Screen Glance Declined By Agent":
        if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession())
          this.toastrService.error(this.webrtcInfoService.generateEndReason("BARGEIN_DECLINED_BY_AGENT", {
            agentLanId: response.To,
          }));
        this.auditService.AuditScreenGlance('decline', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEIN_DECLINED_BY_AGENT", {
          agentLanId: response.To,
        }));
        break;
      case "Screen Glance Declined Due To No Response From Agent":
        if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession())
          this.toastrService.error(this.webrtcInfoService.generateEndReason("BARGEIN_DECLINED_NO_RESPONSE", {
            agentLanId: response.To,
          }));
        this.auditService.AuditScreenGlance('decline', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEIN_DECLINED_NO_RESPONSE", {
          agentLanId: response.To,
        }));
        break;
      case "Screen Glance Declined Because Screen Is Locked":
        if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession())
          this.toastrService.error(this.webrtcInfoService.generateEndReason("BARGEIN_DECLINED_SCREEN_LOCKED", {
            agentLanId: response.To,
          }));
        this.auditService.AuditScreenGlance('decline', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEIN_DECLINED_SCREEN_LOCKED", {
          agentLanId: response.To,
        }));
        break;
      case "Screen Glance Declined Because Screen Is Blocked":
        if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession())
          this.toastrService.error(this.webrtcInfoService.generateEndReason("BARGEIN_DECLINED_SCREEN_BLOCKED", {
            agentLanId: response.To,
          }));
        this.auditService.AuditScreenGlance('decline', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEIN_DECLINED_SCREEN_BLOCKED", {
          agentLanId: response.To,
        }));
        break;
      case "Screen Glance Consent declined as another consent is in progress":
        if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession())
          this.toastrService.error(this.webrtcInfoService.generateEndReason("BARGEININIT_CONSENT_DECLINED_ANOTHER_CONSENT_IN_PROGRESS", {
            agentLanId: response.To,
          }));
        this.auditService.AuditScreenGlance('decline', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEININIT_CONSENT_DECLINED_ANOTHER_CONSENT_IN_PROGRESS", {
          agentLanId: response.To,
        }));
        break;
    }

    if (response.UniqueId === this.webrtcInfoService.getUniqueIdForSession()) {
      this.webrtcInfoService.clearScreenShareScreenInfo();
      this.updateChatUIForAgent(response.To);
    }
  }

  onAgentEndedBargeIn = async (response: { message: string, To: string, UniqueId: string, From: string }) => {
    if (response.From !== this.trsService.supervisorId || response.UniqueId !== this.webrtcInfoService.getUniqueIdForSession())
      return;

    log.info(`Processing ENDBARGEIN received from agent for UniqueId: ${response.UniqueId} with reason: ${response.message}`);

    //This happens when the agent closes the tab/browser and sends endbargein but doesnt close the session
    if (response.message === this.webrtcInfoService.generateEndReason("supervisor-tab-close")) {
      this.closeVideoCall('BARGEIN_ENDED_NETWORK_DISCONNECT');
      return;
    }
    else if (response.message === this.webrtcInfoService.generateEndReason("BARGEIN_ENDED_SCREEN_LOCKED")) {
      this.closeVideoCall('BARGEIN_ENDED_SCREEN_LOCKED');
      return;
    }
    else if (response.message === this.webrtcInfoService.generateEndReason("BARGEIN_ENDED_SCREEN_BLOCKED")) {
      this.closeVideoCall('BARGEIN_ENDED_SCREEN_BLOCKED');
      return;
    }

    const statsReport: RTCStatsReport = await this.peerConnection.getStats();
    this.auditService.AuditScreenGlance('error', response.To, this.webrtcInfoService.generateAuditEndReason("BARGEIN_ENDED_NETWORK_DISCONNECT", {
      errorCode: response.message,
      iceState: `${this.webrtcInfoService.getPreviousICEConnectivityState()} -> ${this.webrtcInfoService.getCurrentICEConnectivityState()}`,
      signallingState: this.peerConnection ? this.peerConnection.signalingState : 'N/A',
      trackReceived: `${this.webrtcInfoService.getIsVideoTrackReceived()}`,
      supervisorCandidateInfo: this.getCandidateInfo(statsReport, "supervisor"),
      agentCandidateInfo: this.getCandidateInfo(statsReport, "agent"),
    }));
    this.closeVideoCall('BARGEIN_ENDED_NETWORK_DISCONNECT');
  }

  showScreenSelectionPopup = (): void => this.sendEvent("SHOW_SCREEN_DEVICE_SELECTION_POPUP", this.webrtcInfoService.getCallingAgentLanId());

  bargeIn = (details: { AgentLanId: string, SelectedScreenIds: number[] }): void => {
    log.info(`Starting Barge-In`);
    if (this.webrtcInfoService.isCallInProgress() === true) {
      log.info(`Call is in progess, updating screens: ${details.SelectedScreenIds}`);
      this.webrtcInfoService.updateSelectedScreenForScreenShare(details.SelectedScreenIds);

      const callingAgentLanId: string = this.webrtcInfoService.getCallingAgentLanId();
      const payload: IWebRTCMessageRequestPayload = {
        MessageType: "BARGEIN",
        Body: '',
        MediaId: 'Video',
        Index: 0,
        From: this.trsService.supervisorId,
        To: callingAgentLanId,
        FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
        ToId: callingAgentLanId,
        Candidate: '',
        ScreenIds: details.SelectedScreenIds,
        ClientName: this.trsService.clientName ?? "",
        CreatedDateTime: getUTCDateObj(),
        Message: '',
        UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
        AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(callingAgentLanId)?.AgentCurrentAuxCode ?? 'na',
      };

      const requestMessage: ISWFHMessagePayload = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

      log.info(`Sending BARGEIN request to update screens`);
      this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);

      this.auditService.AuditScreenGlance("discovery", callingAgentLanId, this.webrtcInfoService.generateAuditEndReason("change-screen-selection", {
        count: `${details.SelectedScreenIds.length}`
      }));

      return;
    }

    this.callType = "bargeIn";
    this.webrtcInfoService.updateCallState('Connecting...');
    this.ShowChat = false;
    this.maximized = true;
    // this.startLocalVideo('BARGEIN');
    this.webrtcInfoService.updateSelectedScreenForScreenShare(details.SelectedScreenIds);
    this.call('BARGEIN');
  }

  // WebRTC Related

  startLocalVideo(messageType: string): void {
    if (messageType == 'BARGEIN') {
      this.localStream.getVideoTracks().forEach((track: { enabled: boolean; }) => {
        track.enabled = true;
      });
    }
    else {
      this.localStream.getTracks().forEach((track: { enabled: boolean; }) => {
        track.enabled = true;
      });
    }
    this.localVideo.nativeElement.srcObject = this.localStream;
  }

  handleReceiveMessage(event: any) {
    log.info(`handleReceiveMessage`, event.data);
  }

  handleReceiveChannelStatusChange(event: any) {
    log.info(`handleReceiveChannelStatusChange`, event);
  }

  receiveChannelCallback(event: RTCDataChannelEvent) {
    let receiveChannel = event.channel;
    log.info(`receiveChannelCallback`, event);
    receiveChannel.onmessage = this.handleReceiveMessage;
    receiveChannel.onopen = this.handleReceiveChannelStatusChange;
    receiveChannel.onclose = this.handleReceiveChannelStatusChange;
    receiveChannel.onerror = this.handleReceiveChannelStatusChange;
  }

  sendChannelOpenedEvent(event: any) {
    log.info(`sendChannelOpenedEvent`, event);
  }

  sendChannelMessageEvent(event: any) {
    log.info(`sendChannelMessageEvent`, event.data);
  }

  sendChannelErrorEvent(event: any) {
    log.info(`sendChannelErrorEvent`, event.data);
  }

  // toggleMuteAudio() {
  //   this.remoteVideo.nativeElement.muted = !this.remoteVideo.nativeElement.muted;
  //   this.RemoteMuted = this.remoteVideo.nativeElement.muted;
  // }

  // toggleMuteVideo() {
  //   if (this.remoteVideo.nativeElement.muted)
  //     this.remoteVideo.nativeElement.play();
  //   else this.remoteVideo.nativeElement.paused();
  // }

  private createPeerConnection = (bargeIn = false): void => {
    log.info(`Creating Peer Connection`);
    this.peerConnection = new RTCPeerConnection(this.webrtcInfoService.getPeerConnectionConfig());

    if (bargeIn === false) {
      const video: RTCRtpTransceiver = this.peerConnection.addTransceiver(this.localStream.getVideoTracks()[0], { streams: [this.localStream] });
      video.direction = 'sendrecv';

      const audio: RTCRtpTransceiver = this.peerConnection.addTransceiver(this.localStream.getAudioTracks()[0], { streams: [this.localStream] });
      audio.direction = 'sendrecv';
    }
    else {
      log.info(`Creating Channel`);
      const sendChannel: RTCDataChannel = this.peerConnection.createDataChannel("screen_track");
      this.peerConnection.ondatachannel = this.receiveChannelCallback.bind(this);

      sendChannel.onopen = this.sendChannelOpenedEvent;
      sendChannel.onmessage = this.sendChannelMessageEvent;
      sendChannel.onerror = this.sendChannelErrorEvent;
    }

    this.peerConnection.onicecandidate = this.handleICECandidateEvent;
    this.peerConnection.oniceconnectionstatechange = this.handleICEConnectionStateChangeEvent;
    this.peerConnection.onsignalingstatechange = this.handleSignalingStateChangeEvent;
    this.peerConnection.ontrack = this.handleTrackEvent;
    this.peerConnection.onicegatheringstatechange = (ev: Event) => { log.info(`ICE Gathering State Changed: ${this.peerConnection.iceGatheringState}`); };
    this.peerConnection.onconnectionstatechange = (ev: Event) => { log.info(`Connection State Changed: ${this.peerConnection.connectionState}`); };

    this.webRTCConnectionTimer = setTimeout(() => this.closeVideoCall('connection-timeout'), this.appConfig.ScreenGlance.ConnectionTimeout);
  }

  call = async (messageType: 'OFFER' | 'BARGEIN'): Promise<void> => {
    this.webrtcInfoService.updateCallingAgentLanId(this.trsService.selectedAgentId);

    const callingAgentLanId: string = this.webrtcInfoService.getCallingAgentLanId();

    if (messageType === 'BARGEIN')
      this.auditService.AuditScreenGlance('start', callingAgentLanId, `${this.webrtcInfoService.getUniqueIdForSession()}|Available Screens: ${this.webrtcInfoService.getScreenShareDetails().length}| Selected Screens: ${this.webrtcInfoService.getSelectedScreensForScreenShare().length}`);

    this.createPeerConnection(messageType === 'BARGEIN' ? true : false);

    // try {
    this.offerOptions.offerToReceiveAudio = messageType === 'BARGEIN' ? false : true;

    const offer: RTCSessionDescriptionInit = await this.peerConnection.createOffer(this.offerOptions);
    log.info(`SDP Offer Created:\n${offer.sdp}`);

    await this.peerConnection.setLocalDescription(offer);

    const payload: IWebRTCMessageRequestPayload = {
      MessageType: messageType,
      Body: offer.sdp || '',
      MediaId: 'Video',
      Index: 0,
      From: this.trsService.supervisorId,
      To: callingAgentLanId,
      FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
      ToId: callingAgentLanId,
      Candidate: '',
      ScreenIds: this.webrtcInfoService.getSelectedScreensForScreenShare(),
      ClientName: this.trsService.clientName ?? "",
      CreatedDateTime: getUTCDateObj(),
      Message: '',
      UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
      AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(callingAgentLanId)?.AgentCurrentAuxCode ?? 'na',
    };

    const requestMessage: ISWFHMessagePayload = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

    log.info(`Sending ${messageType} request`);
    this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);

    this.updateChatUIForAgent(callingAgentLanId);
    // }
    // catch (err: any) {
    //   this.handleGetUserMediaError(err);
    // }
  }

  // private handleGetUserMediaError(e: Error): void {
  //   switch (e.name) {
  //     case 'NotFoundError':
  //       alert(
  //         'Unable to open your call because no camera and/or microphone were found.'
  //       );
  //       break;
  //     case 'SecurityError':
  //     case 'PermissionDeniedError':
  //       // Do nothing; this is the same as the user canceling the call.
  //       break;
  //     default:
  //       log.error(`handleGetUserMediaError`, e);
  //       break;
  //   }
  //   this.closeVideoCall();
  // }

  public closeVideoCall = (reason: callCloseReasons, statsReport: RTCStatsReport | null = null): void => {
    log.info(`Closing WebRTC Call - ${reason}`);

    const callingAgentLanId: string = this.webrtcInfoService.getCallingAgentLanId();
    const payload: IWebRTCMessageRequestPayload = {
      MessageType: "ENDBARGEIN",
      Body: '',
      MediaId: 'Video',
      Index: 0,
      From: this.trsService.supervisorId,
      To: callingAgentLanId,
      FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
      ToId: callingAgentLanId,
      Candidate: '',
      ScreenIds: this.webrtcInfoService.getSelectedScreensForScreenShare(),
      ClientName: this.trsService.clientName ?? "",
      CreatedDateTime: getUTCDateObj(),
      Message: '',
      UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
      AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(callingAgentLanId)?.AgentCurrentAuxCode ?? 'na',
    };
    let requestMessage: ISWFHMessagePayload;

    switch (reason) {
      case 'end':
      case 'agent-aux-change-break':
      case 'agent-aux-change-loggedout':
      case 'agent-change':
      case 'navigate-all-agents':
      case 'refresh':
      case 'navigate-dashboard':
      case 'navigate-gamification':
      case 'navigate-superadmin':
      case 'supervisor-view-hidden':
        let auditReasonText: string = "";

        if (reason === 'agent-aux-change-break')
          auditReasonText = this.webrtcInfoService.generateAuditEndReason(reason, {
            status: this.agentListInfoService.GetLoginStatusMessage(callingAgentLanId).toLowerCase(),
          });
        else auditReasonText = this.webrtcInfoService.generateAuditEndReason(reason);

        payload.Message = this.webrtcInfoService.generateEndCode(reason);
        requestMessage = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

        log.info(`Sending ENDBARGEIN with reason: ${reason}`);
        this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);
        this.auditService.AuditScreenGlance('end', callingAgentLanId, auditReasonText);
        break;
      case 'agent-declined':
        this.auditService.AuditScreenGlance('decline', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason(reason));
        break;
      case 'error':
        this.auditService.AuditScreenGlance('error', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason(reason));
        break;
      case 'connection-timeout':
        payload.Message = this.webrtcInfoService.generateEndCode(reason);
        requestMessage = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

        log.info(`Sending ENDBARGEIN with reason: ${reason}`);
        this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);

        this.auditService.AuditScreenGlance('error', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason(reason, {
          timeout: `${this.appConfig.ScreenGlance.ConnectionTimeout / 1000}`,
          iceState: `${this.webrtcInfoService.getPreviousICEConnectivityState()} -> ${this.webrtcInfoService.getCurrentICEConnectivityState()}`,
          signallingState: this.peerConnection ? this.peerConnection.signalingState : 'N/A',
          trackReceived: `${this.webrtcInfoService.getIsVideoTrackReceived()}`,
          supervisorCandidateInfo: this.getCandidateInfo(statsReport, "supervisor"),
          agentCandidateInfo: this.getCandidateInfo(statsReport, "agent"),
        }));
        break;
      case 'BARGEIN_ENDED_SCREEN_LOCKED':
        this.auditService.AuditScreenGlance('end', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason(reason));
        break;
      case 'BARGEIN_ENDED_SCREEN_BLOCKED':
        this.auditService.AuditScreenGlance('end', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason(reason));
        break;
      case 'ice-disconnected':
        payload.Message = this.webrtcInfoService.generateEndCode(reason);
        requestMessage = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);
        log.info(`Sending ENDBARGEIN with reason: ${reason}`);
        this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);

        this.auditService.AuditScreenGlance('error', callingAgentLanId, this.webrtcInfoService.generateAuditEndReason(reason, {
          iceState: `${this.webrtcInfoService.getPreviousICEConnectivityState()} -> ${this.webrtcInfoService.getCurrentICEConnectivityState()}`,
          signallingState: this.peerConnection ? this.peerConnection.signalingState : 'N/A',
          trackReceived: `${this.webrtcInfoService.getIsVideoTrackReceived()}`,
          supervisorCandidateInfo: this.getCandidateInfo(statsReport, "supervisor"),
          agentCandidateInfo: this.getCandidateInfo(statsReport, "agent"),
        }));
        break;
      case 'ice-signaling-closed':
        log.info(`Call closed due to ${reason}`);
        break;
    }

    this.sendEvent("HIDE_SCREEN_DEVICE_SELECTION_POPUP", {});
    this.callTime = 0;
    clearTimeout(this.webRTCConnectionTimer);
    clearInterval(this.callCounter);
    clearInterval(this.glanceSessionHeartbeat);
    document.removeEventListener("visibilitychange", this.visibilityHandler);
    this.webrtcInfoService.updateCallState('None');
    this.isAnswerReceived = false;
    this.pendingIceCandidates = [];
    this.webrtcInfoService.updateCallingAgentLanId('');
    this.webrtcInfoService.clearScreenShareScreenInfo();

    try {
      if (callingAgentLanId != null && this.AgentLanId != null && callingAgentLanId.toLowerCase() === this.AgentLanId.toLowerCase()) {
        this.ShowChat = true;
        this.maximized = false;
        this.updateChatUIForAgent(callingAgentLanId);
      }
      else log.warn(`Not updating chat UI as the calling agent lanId ${callingAgentLanId} does not match current agent lanId ${this.AgentLanId}`);
    } catch (error) { log.error("An error occurred during close call", error); }

    this.closeLocalVideo();
    if (this.peerConnection != null) {
      this.peerConnection.close();
      this.peerConnection.ontrack = null;
      this.peerConnection.onicecandidate = null;
      this.peerConnection.oniceconnectionstatechange = null;
      this.peerConnection.onsignalingstatechange = null;
      this.peerConnection.onicegatheringstatechange = null;
      this.peerConnection.onconnectionstatechange = null;
      this.peerConnection.getTransceivers().forEach((transceiver) => {
        try {
          transceiver.stop();
        } catch (error) { }
      });
    }
  }

  /* ########################  EVENT HANDLER  ################################## */
  private handleICECandidateEvent = (event: RTCPeerConnectionIceEvent) => {
    log.info(`WebRTC Event triggered: handleICECandidateEvent`);

    if (event.candidate == null || event.candidate.candidate == null || event.candidate.candidate === '') {
      log.warn(`Generated ICE Candidate string is null`);
      return;
    }

    if (event.candidate.candidate.includes("srflx") == true) {
      log.warn(`Generated ICE Candidate is of type srflx, ignoring it`);
      return;
    }

    const candidate: RTCIceCandidate = event.candidate;

    if (candidate.candidate != null) {
      const callingAgentLanId: string = this.webrtcInfoService.getCallingAgentLanId();
      const payload: IWebRTCMessageRequestPayload = {
        MessageType: 'TRICKLEICE',
        Body: candidate.candidate,
        MediaId: candidate.sdpMid || '',
        Index: candidate.sdpMLineIndex || 0,
        From: this.trsService.supervisorId,
        To: callingAgentLanId,
        FromId: `SUPERVISOR_${this.trsService.supervisorId.toUpperCase()}`,
        ToId: callingAgentLanId,
        Candidate: candidate.candidate,
        ScreenIds: this.webrtcInfoService.getSelectedScreensForScreenShare(),
        ClientName: this.trsService.clientName ?? "",
        CreatedDateTime: getUTCDateObj(),
        Message: '',
        UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
        AgentCurrentAuxCode: this.agentListInfoService.GetAgentInfo(callingAgentLanId)?.AgentCurrentAuxCode ?? 'na',
      };

      const requestMessage: ISWFHMessagePayload = generateMessage('WEBRTC', `TRS_${callingAgentLanId}`, payload, this.trsService);

      log.info(`Sending generated ICE Candidate: ${candidate.candidate}`);
      this.sendEvent("SEND_SCREENGLANCE_MESSAGE", requestMessage);
    }
  };

  private handleICEConnectionStateChangeEvent = async (event: any) => {
    log.info(`WebRTC ICE Connection state changed to ${this.peerConnection.iceConnectionState}`);

    this.webrtcInfoService.updateICEConnectivityState(this.peerConnection.iceConnectionState);

    switch (this.peerConnection.iceConnectionState) {
      case 'closed':
      case 'failed':
      case 'disconnected':
        const statsReport: RTCStatsReport = await this.peerConnection.getStats();
        this.closeVideoCall('ice-disconnected', statsReport);
        break;
      case 'connected':
        clearTimeout(this.webRTCConnectionTimer);
        this.webrtcInfoService.updateIsICEConnectionEstablished(true);
        this.webrtcInfoService.updateCallState('Connected');
        this.startCallTime();
        this.glanceSessionHeartbeat = setInterval(() => {
          const payload: IWebRTCHeartbeatPayload = {
            Message: 'WEBRTCHEARTBEAT',
            UniqueId: this.webrtcInfoService.getUniqueIdForSession(),
          };

          log.info(`Sending Screen Glance Heartbeat`);
          this.sendEvent("SEND_SCREENGLANCE_HEARTBEAT", payload);
        }, this.appConfig.ScreenGlance.SessionHeartBeatFrequency);

        document.addEventListener("visibilitychange", this.visibilityHandler);

        if (this.webrtcInfoService.getIsVideoTrackReceived() === true && this.webrtcInfoService.getIsICEConnectionEstablished() === true)
          this.auditService.AuditScreenGlance('connected', this.webrtcInfoService.getCallingAgentLanId(), `${this.webrtcInfoService.getUniqueIdForSession()}`);
        break;
    }
  };

  private handleSignalingStateChangeEvent = (event: Event) => {
    log.info(`WebRTC Signalling State Changed: ${this.peerConnection.signalingState}`);
    switch (this.peerConnection.signalingState) {
      case 'closed':
        this.closeVideoCall('ice-signaling-closed');
        break;
    }
  };

  private handleTrackEvent = (event: RTCTrackEvent): void => {
    log.info(`WebRTC Event triggered: handleTrackEvent: ${event.transceiver.receiver.track.kind}`);
    if (event.transceiver.receiver.track.kind === 'video') {
      this.remoteVideo.nativeElement.srcObject = new MediaStream([event.track]);
      this.webrtcInfoService.updateIsVideoTrackReceived(true);

      if (this.webrtcInfoService.getIsVideoTrackReceived() === true && this.webrtcInfoService.getIsICEConnectionEstablished() === true)
        this.auditService.AuditScreenGlance('connected', this.webrtcInfoService.getCallingAgentLanId(), `${this.webrtcInfoService.getUniqueIdForSession()}`);
    }

    // if (event.transceiver.receiver.track.kind == 'audio') {
    //   let inboundStream = this.remoteVideo.nativeElement.srcObject;
    //   inboundStream.addTrack(event.track);
    //   this.remoteVideo.nativeElement.srcObject = inboundStream;
    // }

    this.remoteVideo.nativeElement.muted = this.RemoteMuted = this.callType === 'bargeIn' ? true : false;
  };

  addTrickleIceToPeerConnection = async (response: { body: string, index: number, mediaId: string }) => {
    if (response.body == null) {
      log.error(`ICE Candidate body is null`);
      return;
    }

    if (this.peerConnection && this.peerConnection.signalingState != 'closed') {
      const iceCandidate: RTCIceCandidateInit = {
        candidate: response.body,
        sdpMLineIndex: response.index,
        sdpMid: response.mediaId,
      };

      if (this.isAnswerReceived === false) {
        log.info(`Queuing ICE Candidate as ANSWER is not yet received`);
        this.pendingIceCandidates.push(iceCandidate);
      }
      else {
        log.info(`Adding ICE Candidate to peer connection: ${iceCandidate.candidate}`);
        await this.peerConnection.addIceCandidate(iceCandidate);
      }
    }
  }

  // private async requestMediaDevices(): Promise<void> {
  //   try {
  //     const cameraDeviceInfo: MediaDeviceInfo | null = GetCameraDeviceInfo();

  //     if (cameraDeviceInfo != null) {
  //       log.info(`Camera: ${cameraDeviceInfo.label}`);
  //       const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: { deviceId: { exact: cameraDeviceInfo.deviceId } } });

  //       log.info(`Camera Ready`);
  //       this.cameraReady = true;
  //       this.localStream = stream;
  //     }
  //     else {
  //       const devices: MediaDeviceInfo[] = await navigator.mediaDevices.enumerateDevices();
  //       const camera: MediaDeviceInfo | undefined = devices.find((device: { kind: string; }) => device.kind == "videoinput");

  //       if (camera != null) {
  //         log.info(`Camera: ${camera.label}`);

  //         const stream: MediaStream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

  //         log.info(`Camera Ready`);
  //         this.cameraReady = true;
  //         this.localStream = stream;
  //       }
  //     }

  //     this.callState = 'None';
  //     // pause all tracks
  //     this.pauseLocalVideoAndAudio();
  //   } catch (err: any) {
  //     // disable call icon
  //     this.callState = 'None';
  //     //log to console first 
  //     if (err.name == "NotFoundError" || err.name == "DevicesNotFoundError") {
  //       //required track is missing 
  //       log.error(`Device not found`, err);
  //       this.logUploader.error("checkCameraAccess", `Device not found`, err);
  //     } else if (err.name == "NotReadableError" || err.name == "TrackStartError") {
  //       //webcam or mic are already in use 

  //       // this.toastrService.warning("Please close any other application(s) using the camera and try again");
  //       // console.log(`%c Device already in use `
  //       // , 'background: red; color: white');
  //       // this.logUploader.error("checkCameraAccess", `Device already in use`, err);

  //     } else if (err.name == "OverconstrainedError" || err.name == "ConstraintNotSatisfiedError") {
  //       //constraints can not be satisfied by avb. devices 
  //       log.error(`constraints can not be satisfied by avb. devices`, err);
  //       this.logUploader.error("checkCameraAccess", `constraints can not be satisfied by avb. devices`, err);
  //     } else if (err.name == "NotAllowedError" || err.name == "PermissionDeniedError") {
  //       //permission denied in browser 
  //       log.error(`permission denied in browser`, err);
  //       this.logUploader.error("checkCameraAccess", `permission denied in browser`, err);
  //       //permission denied in browser 
  //     } else if (err.name == "TypeError") {
  //       //empty constraints object 
  //       log.error(`empty constraints object`, err);
  //       this.logUploader.error("checkCameraAccess", `empty constraints object`, err);
  //     } else {
  //       log.error(`some error occurred`, err);
  //       //other errors 
  //     }
  //   }
  // }

  pauseLocalVideo(): void {
    log.info(`pause local video`);
    this.localStream.getVideoTracks().forEach((track: MediaStreamTrack) => {
      track.enabled = !track.enabled;
    });
    this.localVideo.nativeElement.srcObject = this.localStream;
    this.LocalVideoMute = !this.LocalVideoMute;
  }

  pauseLocalAudio(): void {
    log.info(`pause audio video`);
    this.localStream.getAudioTracks().forEach((track: MediaStreamTrack) => {
      track.enabled = !track.enabled;
    });
    this.localVideo.nativeElement.srcObject = this.localStream;
    this.LocalAudioMute = !this.LocalAudioMute;
  }

  pauseLocalVideoAndAudio(): void {
    log.info(`pause local all stream`);
    this.localStream.getTracks().forEach((track: MediaStreamTrack) => {
      track.enabled = !track.enabled;
    });
    this.localVideo.nativeElement.srcObject = this.localStream;
    this.LocalVideoMute = !this.LocalVideoMute;
  }

  closeLocalVideo(): void {
    log.info(`close local video`);

    if (this.localStream != null) {
      this.localStream.getTracks().forEach((track: MediaStreamTrack) => track.stop());
      this.localVideo.nativeElement.srcObject = undefined;
    }
  }

  setRemoteDescriptionOfPeerConnection = async (response: { body: string }): Promise<void> => {
    log.info(`setRemoteDescriptionOfPeerConnection`);
    if (this.peerConnection && this.peerConnection.signalingState != 'closed') {
      const remoteDescription: RTCSessionDescriptionInit = { type: "answer", sdp: response.body };
      await this.peerConnection.setRemoteDescription(new RTCSessionDescription(remoteDescription));

      log.info(`ANSWER setting remote description to\n${response.body}`);

      this.isAnswerReceived = true;

      if (this.pendingIceCandidates.length > 0) {
        log.info(`Unqueueing pending ICE Candidates as ANSWER is received`);

        for (let index = 0; index < this.pendingIceCandidates.length; index++) {
          const iceCandidate: RTCIceCandidateInit = this.pendingIceCandidates[index];
          log.info(`Adding ICE Candidate to peer connection: ${iceCandidate.candidate}`);
          await this.peerConnection.addIceCandidate(iceCandidate);
        }

        this.pendingIceCandidates = [];
      }
    }
    else log.warn(`Peer Connection is not available or closed while setting remote description`);
  }

  handlePeepResponse = (info: any): void => {
    if (info != null) {
      if (this.AgentLanId === info.AgentLanId)
        this.setPeepButtonVisibility(info.AgentLanId);
    }
  }

  handleScreenGrabResponse = (info: any): void => {
    if (info != null) {
      if (this.AgentLanId === info.From) {
        this.setScreenGrabButtonVisibility(info.From);
      }
    }
  }

  setPeepButtonVisibility = (lanId: string): void => {
    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanId);

    this.isPeepButtonEnabled = false;

    if (this.webrtcInfoService.isCallInProgress() === true)
      return;

    if (agentInfo != null) {
      const currentAuxCode: AgentAuxStatus = getAgentAuxStatus(agentInfo);

      if (agentInfo.IsScreenBlocked === false && currentAuxCode !== "logged-out" && currentAuxCode !== "aux") {
        const isPeepFeatureEnabled: boolean = isPeepButtonEnabled(lanId, this.agentListInfoService);

        if (isPeepFeatureEnabled === true && agentInfo.IsCheckInRequestSent == false)
          this.isPeepButtonEnabled = true;
      }
    }
    else log.error(`There is no agent info available in service for agent ${lanId}`);
  }

  setScreenGrabButtonVisibility = (lanId: string): void => {
    const agentInfo: Agent | null = this.agentListInfoService.GetAgentInfo(lanId);

    if (agentInfo != null) {
      const currentAuxCode: AgentAuxStatus = getAgentAuxStatus(agentInfo);
      if (currentAuxCode === "logged-out") {
        this.isScreenGrabButtonEnabled = false;
      }
      else {
        this.isScreenGrabButtonEnabled = this.appConfig.ScreenGrab.Enable && this.agentListInfoService.GetScreenGrabRequestStatus(lanId) == false;
      }
    }
  }

  refreshMediaURLs = (eventId: string, violationId: string) => {
    this.sendEvent("REFRESHMEDIAURL_REQUEST", {
      "AgentLanId": this.AgentLanId,
      "EventId": eventId,
      "ViolationId": violationId,
      "supervisorId": this.trsService.supervisorId,
    });
  }

  toggleEmojiPickerVisibility = (): void => {
    this.isEmojiPickerShown = !this.isEmojiPickerShown;
  }

  addEmoji = (event: any): void => {
    if (this.txtChat == null)
      this.txtChat = "";
    if (this.txtChat !== "") {
      let input: HTMLInputElement = document.getElementById(`___chat-text-input-${this.AgentLanId}`) as HTMLInputElement;
      let start: number = input.selectionStart ?? 0;
      let end: number = input.selectionEnd ?? 0;
      this.txtChat = `${input.value.substring(0, start)}${event.emoji.native}${input.value.substring(end)}`;
    }
    else this.txtChat = `${this.txtChat}${event.emoji.native}`
    this.isEmojiPickerShown = false;
  }

  updateComponentLabels = (): void => {
    this.chatSectionLabel = this.translationService.translate("Chat");
    this.peepLabel = this.translationService.translate("Check-In");
    this.screenblockLabel = this.translationService.translate("Block");
    this.screenUnblockLabel = this.translationService.translate("Unblock");
    this.screenGrabLabel = this.translationService.translate("Screen Grab");
    // this.callLabel = this.translationService.translate("Call");
    this.bargeInLabel = this.translationService.translate("Assist");
    this.deactivateStealthModeLabel = this.translationService.translate("Deactivate Stealth Mode");
    this.showChatLabel = this.translationService.translate("Show Chat");
    this.hideChatLabel = this.translationService.translate("Hide Chat");
    this.minimizeLabel = this.translationService.translate("Minimize");
    this.maximizeLabel = this.translationService.translate("Maximize");
    this.noDataFoundLabel = this.translationService.translate("No Data Found");
    this.loadingLabel = this.translationService.translate("Loading");
    this.muteAudioLabel = this.translationService.translate("Mute Audio");
    this.unmuteAudioLabel = this.translationService.translate("Unmute Audio");
    this.muteVideoLabel = this.translationService.translate("Mute Video");
    this.unmuteVideoLabel = this.translationService.translate("Unmute Video");
    this.endCallLabel = this.translationService.translate("End Screen Glance");
    this.eventIdLabel = this.translationService.translate("Event Id");
    this.emojiLabel = this.translationService.translate("Emoji Selector");
    this.sendAMessageLabel = this.translationService.translate("Send a message");
    this.stealthModeRequestedLabel = this.translationService.translate("Stealth Mode Requested");
    this.stealthModeApprovalLabel = this.translationService.translate("Approval");
    this.allowLabel = this.translationService.translate("Allow");
    this.denyLabel = this.translationService.translate("Deny");
    this.noScreensAvailableErrorMessage = this.translationService.translate("No screen capture devices found for the agent");
    this.glanceLicenseLimitErrorMessage = this.translationService.translate("Screen Glance license limit reached");
    this.changeScreenLabel = this.translationService.translate("Change Screen");
  }

  hasAgentGoneOnBreak = (agentInfo: Agent): boolean => {
    const currentAuxCode: AgentAuxStatus = getAgentAuxStatus(agentInfo);

    return currentAuxCode === "aux" && this.agentListInfoService.GetLoginStatusMessage(agentInfo.LanID).toLowerCase() === "break"
  }

  isSelectedAgentOnCall = (): boolean => {
    if (this.webrtcInfoService.getCallingAgentLanId() == null || this.AgentLanId == null)
      return false;
    else return this.webrtcInfoService.getCallingAgentLanId().toLowerCase() == this.AgentLanId.toLowerCase()
  };

  visibilityHandler = (): void => {
    if (document.hidden === true)
      this.closeVideoCall('supervisor-view-hidden');
  }

  getCandidateInfo = (statsReport: RTCStatsReport | null, role: 'supervisor' | 'agent'): string => {
    let selectedPair: any = null;
    const candidateReport: Record<string, any> = {};

    statsReport?.forEach((report) => {
      if (report.type === "candidate-pair" && report.state === "succeeded")
        selectedPair = report;

      if (report.type === "local-candidate" || report.type === "remote-candidate")
        candidateReport[report.id] = report;
    });

    if (selectedPair != null) {
      const candidateId = role === "supervisor" ? selectedPair.localCandidateId : selectedPair.remoteCandidateId
      const report = candidateReport[candidateId];
      const type = report?.candidateType || "unknown";
      const protocol = report?.protocol || "unknown";

      return `${type}-${protocol}`
    }
    else return ``;
  }
}
